import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootSaga from '@/Redux/rootSaga';
import accountsInterestSlice from '@/Redux/slices/AccountsInterestSlice';
import accountsManagementSlice from '@/Redux/slices/AccountsManagementSlice';
import postManagementSlice from '@/Redux/slices/PostManagementSlice';
import reportSlice from '@/Redux/slices/ReportSlice';
import accountReducer from '@/Slices/AccountSlice';
import censoredSlice from '@/Slices/CensorshipSlice';
import ModalSlice from '@/Slices/ModalSlice';
import settingSlice from '@/Slices/SettingSlice';
import userRoleSlice from '@/Slices/UserRoleSlice';
import whitelistDomainSlice from '@/Slices/WhitelistDomainSlice';

// Slices
import affiliateSlice from './slices/AffiliateSlice';
import betaFeaturesReducer from './slices/BetaFeaturesSlice';
import LiteAppSlice from './slices/LiteAppSlice';
import liveShowSlice from './slices/LiveShowSlice';
import MyPageSlice from './slices/MyPageSlice';
import PostCollectionSlice from './slices/PostCollectionSlice';
import RebateOverrideSlice from './slices/RebateOverrideSlice';
import RebateTncSlice from './slices/RebateTncSlice';
import reserverProfileIdSlice from './slices/ReservedProfileIdSlice';
import snsConnectionReducer from './slices/SnsConnectionSlice';
import userGroupsSlice from './slices/UserGroupsSlice';
import vodSlice from './slices/VodSlice';
import userVerifySlice from './slices/UserVerifySlice';
import crawledPostManagementSlice from './slices/CrawledPostManagementSlice';

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  account: accountReducer,
  accountsManagement: accountsManagementSlice,
  accountsInterest: accountsInterestSlice,
  affiliate: affiliateSlice,
  betaFeatures: betaFeaturesReducer,
  censorship: censoredSlice,
  liteApp: LiteAppSlice,
  liveShow: liveShowSlice,
  modal: ModalSlice,
  myPage: MyPageSlice,
  postCollection: PostCollectionSlice,
  postManagement: postManagementSlice,
  rebateOverride: RebateOverrideSlice,
  rebateTnc: RebateTncSlice,
  report: reportSlice,
  setting: settingSlice,
  userGroups: userGroupsSlice,
  userVerify: userVerifySlice,
  userRole: userRoleSlice,
  vod: vodSlice,
  whitelistDomain: whitelistDomainSlice,
  snsConnection: snsConnectionReducer,
  reservedProfileId: reserverProfileIdSlice,
  crawledPostManagement: crawledPostManagementSlice,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
